var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    staticClass: "pa-16"
  }, [_c('vertical-form-table', _vm._b({
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "주소"
  }, [_c('v-address-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    model: {
      value: _vm.inputs,
      callback: function ($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  })], 1), _c('template', {
    slot: "프로필사진"
  }, [_c('v-responsive', {
    staticClass: "w-100 mw-md-100px rounded-lg border",
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-file-btn', {
    staticClass: "pa-0",
    attrs: {
      "accept": "image/*",
      "plain": "",
      "text": "",
      "block": "",
      "height": "100%"
    },
    model: {
      value: _vm.inputs.profile,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "profile", $$v);
      },
      expression: "inputs.profile"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profileSrc,
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.profileSrc,
      expression: "!profileSrc"
    }],
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": "",
      "fill-height": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-image")]), _c('span', {
    staticClass: "page-text"
  }, [_vm._v("프로필사진")])], 1)], 1)], 1)], 1)], 1)], 1)], 2), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "disabled": !_vm.isValid,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("저장하기")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }